// LEGACY UI: replace with Field with Select (or NativeSelect) from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import FormError from "@casino/legacyUi/form/FormError";
import { type ForwardedRef, forwardRef } from "react";
import CustomSelect from "./CustomSelect";

type Props = SelectProps & {
  error?: string;
  maxWidth?: string;
  ref?: ForwardedRef<HTMLSelectElement>;
  options?: SelectOption[];
  secondaryOptions?: SelectOption[];
  secondaryOptionsLabel?: string;
  enableEmptyValue?: boolean;
  skipErrorMessage?: boolean;
};

const FormSelect = forwardRef<HTMLSelectElement, Props>((props, ref) => {
  const {
    name,
    options,
    secondaryOptions = [],
    secondaryOptionsLabel = "",
    error = "",
    label = "",
    placeholder = "",
    enableEmptyValue = false,
    skipErrorMessage = false,
    ...selectProps
  } = props;
  const labelTranslation = useTranslation(label);
  const placeholderTranslation = useTranslation(placeholder);
  return (
    <div className="grid gap-0">
      <CustomSelect
        name={name}
        label={labelTranslation}
        ref={ref}
        placeholder={placeholderTranslation}
        error={!!error}
        {...selectProps}
      >
        <option value="" disabled={!enableEmptyValue} selected>
          {placeholderTranslation}
        </option>

        {options?.map(({ label: optionLabel, value }) => (
          <option key={value} label={optionLabel} value={value}>
            {optionLabel}
          </option>
        ))}

        {secondaryOptions && secondaryOptions.length > 0 && (
          <optgroup label={secondaryOptionsLabel}>
            {secondaryOptions.map(({ label: optionLabel, value }) => (
              <option key={value} label={optionLabel} value={value}>
                {optionLabel}
              </option>
            ))}
          </optgroup>
        )}
      </CustomSelect>
      {!skipErrorMessage && (
        <FormError message={error} data-testid={`${name}-form-error`} />
      )}
    </div>
  );
});

export default FormSelect;
